import { Grid, Typography } from "@mui/material"
import { motion } from "framer-motion"

const AiDataTransferTop = () => {
    return <Grid container alignItems="center" justifyContent="space-between" spacing={2} sx={{ pt: { md: 0, xs: 8 }, pb: { md: 0, xs: 5 } }}>
        <Grid item xs={12} lg={5} md={6}>
            <Grid item xs={12} sx={{ pb: 2 }}>
                <motion.div
                    initial={{ opacity: 0, translateY: 550 }}
                    animate={{ opacity: 1, translateY: 0 }}
                    transition={{
                        type: 'spring',
                        stiffness: 150,
                        damping: 30
                    }}
                >
                    <Typography
                        variant="h1"
                        color="white"
                        sx={{
                            fontSize: { xs: '1.825rem', sm: '2rem', md: '2.5rem' },
                            fontWeight: 700,
                            lineHeight: { xs: 1.3, sm: 1.3, md: 1.3 }
                        }}
                    >
                        <span>AI Data Transfer</span>
                    </Typography>
                </motion.div>
            </Grid>
            <Grid item xs={12}>
                <motion.div
                    initial={{ opacity: 0, translateY: 550 }}
                    animate={{ opacity: 1, translateY: 0 }}
                    transition={{
                        type: 'spring',
                        stiffness: 150,
                        damping: 30,
                        delay: 0.2
                    }}
                >
                    <Typography
                        variant="h1"
                        component="div"
                        color="white"
                        sx={{
                            fontSize: { xs: '0.875rem', md: '1rem' },
                            fontWeight: 400,
                            lineHeight: { xs: 1.4, md: 1.4 }
                        }}
                    >
                        外部AI事業者への個人情報の送信に関する説明書
                    </Typography>
                </motion.div>
            </Grid>
        </Grid>
    </Grid>
}

export default AiDataTransferTop